import React, { useEffect, useMemo } from 'react';
import { Route } from 'react-router';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import './App.css';
import { ConfigProvider, message } from 'antd';
import Cookies from 'js-cookie';
import {
  WhatsAppOutlined,
  InstagramOutlined,
  FacebookOutlined,
} from '@ant-design/icons';
import Homepage from './containers/Homepage/Homepage';
import Contact from './containers/Contact/Contact';
import Reservation from './containers/Reservation/Reservation';
import Auth from './containers/Auth/Auth';
import SignUp from './containers/Auth/SignUp';
import NavigationBar from './containers/NavigationBarV3/NavigationBarV3';
import MenuBar from './containers/NavigationBarV3/MenuV3';
import { AppWrapper, Footer } from './App.styled';
import { FlexDivCenter } from './components/Typography/Typography';
import { fetchActiveUserAction } from './data/modules/auth/auth.actions';
import { getAllProductsAction } from './data/modules/products/products.actions';
import UseMedia from './customHooks/UseMedia';
import Rent from './containers/Rent/Rent';
import Sale from './containers/Sale/Sale';
import Event from './containers/Event/Event';
import Services from './containers/Services/Services';
import { getWeboConfig } from './utils';
import StudentCard from './containers/StudentCard/StudentCard';
import axios from 'axios'

const routes = [
  {
    path: '/',
    component: window.location.host.includes("colman") ? StudentCard : Services,
    isExact: true,
  },
  { path: '/gift', component: Homepage, isExact: true },
  { path: '/contact', component: Contact, isExact: true },
  { path: '/signup', component: SignUp, isExact: true },
  { path: '/student-card', component: StudentCard, isExact: true },
  { path: '/product/:productId', component: Reservation, isExact: true },
  { path: '/rent', component: Rent, isExact: true },
  { path: '/sale', component: Sale, isExact: true },
  { path: '/event', component: Event, isExact: true },
  { path: '/services', component: Services, isExact: true },
  // { path: "/template", component: <div>template</div>, isExact: true }
];

function App() {
  const { activeUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { isMobile } = UseMedia();

  useEffect(() => {
    console.log(location.pathname);
    const referrer = location?.pathname;
    if (location?.pathname?.includes('signup')) {
      return;
    }
    dispatch(getAllProductsAction());
    if (Cookies.get('jwt_store_auth')) {
      dispatch(fetchActiveUserAction()).catch((_) => {
        history.push(`/auth`, { referrer });
      })
    } else {
      history.push(`/auth`, { referrer });
    }
  }, []);

  const isAuth = useMemo(() => {
    const res = !!activeUser;
    return res;
  }, [activeUser]);

  function handleSocial(social) {
    const config = getWeboConfig(`SG_SOCIAL_${social}`);
    if (!config) return;
    window.open(config);
  }

  return (
    <ConfigProvider direction="rtl">
      <AppWrapper>
        {getWeboConfig('SG_ENABLE_SOCIAL') && isMobile && (
          <FlexDivCenter>
            <WhatsAppOutlined
              style={{
                color: 'white',
                fontSize: 24,
                margin: '5px 10px',
                cursor: 'pointer',
              }}
              onClick={() => handleSocial('whatsapp')}
            />
            <FacebookOutlined
              style={{
                color: 'white',
                fontSize: 24,
                margin: '5px 10px',
                cursor: 'pointer',
              }}
              onClick={() => handleSocial('facebook')}
            />
            <InstagramOutlined
              style={{
                color: 'white',
                fontSize: 24,
                margin: '5px 10px',
                cursor: 'pointer',
              }}
              onClick={() => handleSocial('instagram')}
            />
          </FlexDivCenter>
        )}
        <Route exact key="/signup" path="/signup" component={SignUp} />
        {isAuth ? (
          <div style={{ marginBottom: 40 }}>
            {isMobile ? (
              <NavigationBar style={{ zIndex: 9999 }} />
            ) : (
              <MenuBar style={{ zIndex: 9999 }} />
            )}

            {routes.map((route) => (
              <Route
                exact={route.isExact}
                key={route.path}
                path={route.path}
                component={route.component}
              />
            ))}
          </div>
        ) : (
          <Route exact key="/auth" path="/auth" component={Auth} />
        )}
        <Footer>
          <FlexDivCenter style={{ color: 'white', alignItems: 'center' }}>
            <a
              href="https://Webo-Tech.com"
              style={{ color: 'white' }}
              target="_blank"
            >
              &nbsp;פותח ע״י
              <span style={{ textDecoration: 'underline' }}>
                וובוטק פתרונות טכנולוגיה
              </span>
            </a>
          </FlexDivCenter>
        </Footer>
      </AppWrapper>
    </ConfigProvider>
  );
}

export default App;
